import { withProps } from "recompose";

export const withInitialDeliveryDate = withProps(({ parcel }) => ({
  initialDeliveryDate: parcel.deliveryDate,
}));
